import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Hot Springs needed",
      "Ideal for ASU Red Wolves students studying abroad",
      "Perfect for NEA Baptist and St. Bernards medical professionals",
      "Great for NE Arkansas families planning cruises from New Orleans",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Jonesboro post offices",
      "Good for planned international trips connecting through MEM",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Craighead County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "In-state: Arkansas Passport Center, Hot Springs (~185 mi)",
      "NPIC appointment required — call before visiting Hot Springs (~3 hrs via US-67/I-30)",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function JonesboroProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Jonesboro, AR"
      introText="Jonesboro and Northeast Arkansas travelers — ASU Red Wolves students heading to study abroad in Spain and Italy, NEA Baptist and St. Bernards medical professionals attending international conferences, and Craighead County families planning Caribbean cruises from New Orleans — have several options for getting a passport fast. Here is how they compare, and why most Jonesboro residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the 3-hour drive to Hot Springs."
      options={options}
      emergencyDescription="Arkansas Passport Center is in Hot Springs (~185 mi, 3 hrs via US-67 and I-30). For life-or-death emergencies, call NPIC at 1-877-487-2778 to book an appointment at 400 N College Ave, Hot Springs, AR 71901. No walk-ins accepted."
      disclaimerText="*Processing speed depends on eligibility and documentation. The Arkansas Passport Center is in Hot Springs, AR. Not all applicants qualify for Regional Agency Processing."
    />
  );
}